import * as React from 'react';
import { HOC, HOCProps } from "@ajayvikas/react-fluent-validation";

declare type SelectProps = React.InputHTMLAttributes<HTMLSelectElement>;
export const Select = HOC<SelectProps>(({ message, ...props }: HOCProps<SelectProps>) => {
    const hasMessage = !!message;
    const controlClassName = hasMessage ? "fluent-invalid-control" : "fluent-valid-control";
    const {className, ...rest} = props
    return <React.Fragment>
        <select {...rest} className={`${controlClassName} ${className}`} />
        {hasMessage && <span className="fluent-invalid-feedback">{message}</span>}
    </React.Fragment>
}, "blurOrChange")